import * as Sentry from '@sentry/react'

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined
const IS_PROD = import.meta.env.PROD

export function initSentry() {
  if (!IS_PROD || !DSN) return

  Sentry.init({
    dsn: DSN,
    environment: 'production',
    // Traces sur 10 % des requêtes — ajuster selon le volume
    tracesSampleRate: 0.1,
    // Masquer les données personnelles avant envoi
    beforeSend(event) {
      if (event.user) {
        delete event.user.email
        delete event.user.username
        delete event.user.ip_address
      }
      return event
    },
    // Ne pas envoyer les erreurs de réseau inoffensives
    ignoreErrors: [
      'Network request failed',
      'Failed to fetch',
      'ChunkLoadError',
    ],
  })
}

export function setSentryUser(userId: string) {
  if (!IS_PROD) return
  Sentry.setUser({ id: userId })
}

export function clearSentryUser() {
  if (!IS_PROD) return
  Sentry.setUser(null)
}

export const SentryErrorBoundary = Sentry.ErrorBoundary
